import { Users, TrendingUp, Filter, CheckSquare, Building2, Zap, BarChart3 } from 'lucide-react'

/** The CRM's tabs, each with the feature flag that offers it (null = always). */
export const CRM_TABS = [
  { id: 'contacts', label: 'Contacts', icon: Users, path: '/crm/contacts', feature: null },
  { id: 'deals', label: 'Deals', icon: TrendingUp, path: '/crm/deals', feature: 'crm_deals' },
  { id: 'segments', label: 'Segments', icon: Filter, path: '/crm/segments', feature: 'crm_segments' },
  { id: 'activities', label: 'Activities', icon: CheckSquare, path: '/crm/activities', feature: 'crm_activities' },
  { id: 'companies', label: 'Companies', icon: Building2, path: '/crm/companies', feature: 'crm_companies' },
  { id: 'automations', label: 'Automations', icon: Zap, path: '/crm/automations', feature: 'crm_automations' },
  { id: 'analytics', label: 'Analytics', icon: BarChart3, path: '/crm/analytics', feature: 'crm_analytics' },
] as const

/** The tab a CRM path belongs to: its first segment after /crm, a contact's page reading as Contacts (SA-1125). */
export function crmTabFor(pathname: string): string {
  const segment = pathname.split('/')[2] ?? ''
  return CRM_TABS.some((t) => t.id === segment) ? segment : 'contacts'
}
